// extracted by mini-css-extract-plugin
export default {"sec-btn1":"PaperFormat_sec-btn1__tgUki","edit":"PaperFormat_edit__ZoTLf","activate":"PaperFormat_activate__wHvUG","flex":"PaperFormat_flex__+42ZC"};